<script setup>
import ReportPage from '../components/ReportPage.vue'
import AnatomyFigure from '../components/AnatomyFigure.vue'
import StatusTag from '../components/StatusTag.vue'
</script>

<template>
  <ReportPage
    section="health-atlas"
    eyebrow="02 · 몸의 위치로 보기"
    title="검진 결과를 몸의 위치와 함께 봅니다"
    lead="번호는 왼쪽·오른쪽 카드와 그림의 표시점이 같습니다. 그림은 설명을 위한 위치 안내이며 진단이 아닙니다."
    :customer-name="report.customer.name"
  >
    <div class="legend">
      <StatusTag state="action"  /><StatusTag state="watch"  /><StatusTag state="good"  /><StatusTag state="unknown"  />
    </div>
    <div class="bodymap">
      <div class="bcol">
        <article v-for="(area, i) in report.health.areas.slice(0, Math.ceil(report.health.areas.length / 2))" :key="area.id" class="bcard">
          <span class="bnum" :class="`marker-${area.state}`">{{ i + 1 }}</span>
          <div>
            <div class="bcard-top"><b>{{ area.label }}</b><StatusTag :state="area.state"  /></div>
            <div class="bval">{{ area.result }}</div>
            <p v-if="area.detail" class="bnote">{{ area.detail }}</p>
          </div>
        </article>
      </div>
      <div class="bfig"><AnatomyFigure :areas="report.health.areas" /><p class="bcap">그림은 위치 안내용이며 실제 장기 상태를 나타내지 않습니다.</p></div>
      <div class="bcol">
        <article v-for="(area, i) in report.health.areas.slice(Math.ceil(report.health.areas.length / 2))" :key="area.id" class="bcard">
          <span class="bnum" :class="`marker-${area.state}`">{{ Math.ceil(report.health.areas.length / 2) + i + 1 }}</span>
          <div>
            <div class="bcard-top"><b>{{ area.label }}</b><StatusTag :state="area.state"  /></div>
            <div class="bval">{{ area.result }}</div>
            <p v-if="area.detail" class="bnote">{{ area.detail }}</p>
          </div>
        </article>
      </div>
    </div>
  </ReportPage>
</template>

<script>
export default { props: { report: { type: Object, required: true } } }
</script>
